"use strict";
/**
 * API 通用契约：统一成功/失败响应结构、分页与错误码。
 * 依据《07-数据模型与API契约》第 3 节。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVITY_RECORD_VIEWS = exports.ERROR_CODES = void 0;
/** 核心错误码 */
exports.ERROR_CODES = [
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'VALIDATION_ERROR',
    'NOT_FOUND',
    'CONFLICT',
    'AGREEMENT_REQUIRED',
    /** OPT-05：确认时协议版本已被其他发布替换，客户端必须重新读取后再确认 */
    'AGREEMENT_VERSION_CHANGED',
    'CONTENT_ACCESS_DENIED',
    'DOWNLOAD_ACCESS_DENIED',
    'ACTIVITY_FULL',
    'ACTIVITY_NOT_REGISTERABLE',
    'DUPLICATE_REGISTRATION',
    'ACCOUNT_MUTED',
    'ACCOUNT_BANNED',
    'RATE_LIMITED',
    /** M0 补充：模拟登录仅在非生产环境可用 */
    'MOCK_LOGIN_DISABLED',
    /** M0 补充：服务端内部错误（对外不暴露细节） */
    'INTERNAL_ERROR',
    /** M0 补充：依赖服务不可用 */
    'SERVICE_UNAVAILABLE',
    /**
     * 交易链路（30 号文档 §4.5）：纯增量追加，不删除、不改名既有码，前端穷举保持兼容。
     */
    // 票种 / 库存
    'TICKET_NOT_FOUND',
    'TICKET_NOT_ON_SALE',
    'TICKET_SOLD_OUT',
    'TICKET_LIMIT_EXCEEDED',
    'TICKET_MEMBER_ONLY',
    'INVENTORY_LOCK_FAILED',
    // 订单
    'ORDER_NOT_FOUND',
    'ORDER_NOT_CANCELLABLE',
    'ORDER_NOT_PAYABLE',
    'ORDER_EXPIRED',
    'ORDER_ALREADY_PAID',
    'ORDER_NOT_REFUNDABLE',
    'DUPLICATE_ORDER',
    'INVALID_ORDER_TRANSITION',
    // 支付
    'PAYMENT_NOT_SUCCEEDED',
    'PAYMENT_AMOUNT_MISMATCH',
    'PAYMENT_ALREADY_SUCCEEDED',
    'PAYMENT_CHANNEL_UNAVAILABLE',
    'PAYMENT_SIGNATURE_INVALID',
    'PAYMENT_NOTIFY_REPLAY',
    'PAYMENT_MERCHANT_MISMATCH',
    // 退款
    'REFUND_NOT_ALLOWED',
    'REFUND_ALREADY_EXISTS',
    'REFUND_AMOUNT_INVALID',
    'REFUND_AMOUNT_EXCEEDS_PAID',
    'REFUND_RETRY_EXHAUSTED',
    'INVALID_REFUND_TRANSITION',
    // 签到
    'CHECKIN_NOT_OPEN',
    'CHECKIN_ALREADY_DONE',
    'CHECKIN_OUT_OF_WINDOW',
    'TICKET_CODE_INVALID',
    'REGISTRATION_REFUNDING',
    // 会员
    'PLAN_NOT_FOUND',
    'PLAN_NOT_ON_SALE',
    'MEMBERSHIP_NOT_FOUND',
    'MEMBERSHIP_ALREADY_LONG_TERM',
    // 借阅
    'BOOK_NOT_BORROWABLE',
    'BOOK_COPY_UNAVAILABLE',
    'BORROW_QUOTA_EXCEEDED',
    'BORROWING_NOT_FOUND',
    'BORROWING_NOT_CANCELLABLE',
    'RESERVATION_ALREADY_EXISTS',
    'RESERVATION_NOT_CANCELLABLE',
    /**
     * 借阅域增量（33 号《图书借阅方案 V1.1》§5.4，6 个，纯追加）。
     */
    'INVALID_BORROWING_TRANSITION',
    'BORROWING_NOT_RETURNABLE',
    'BORROWING_ALREADY_EXISTS',
    'RESERVATION_NOT_FOUND',
    'INVALID_RESERVATION_TRANSITION',
    'PICKUP_LOCATION_NOT_FOUND',
    /**
     * 邮箱注册/登录（34 号文档 N1，纯追加）。
     * 语义：`EMAIL_INVALID` 邮箱格式不合法；`WEAK_PASSWORD` 密码强度不足；
     * `EMAIL_ALREADY_REGISTERED` 邮箱已注册；`INVALID_CREDENTIALS` 登录失败统一码
     * （账号不存在 / 密码错误 / 已锁定一律相同，防账号枚举，HTTP 401）。
     */
    'EMAIL_INVALID',
    'WEAK_PASSWORD',
    'EMAIL_ALREADY_REGISTERED',
    'INVALID_CREDENTIALS',
    /**
     * 邮箱验证码（38 号 N2，纯追加）：
     * `EMAIL_CHANNEL_UNAVAILABLE` 邮件通道未配置/发送失败（503）；
     * `EMAIL_CODE_INVALID` 验证码错误或已过期（400）；
     * `EMAIL_CODE_COOLDOWN` 发送过于频繁（429，冷却期内拒绝）。
     */
    'EMAIL_CHANNEL_UNAVAILABLE',
    'EMAIL_CODE_INVALID',
    'EMAIL_CODE_COOLDOWN',
    // 通用
    'IDEMPOTENCY_KEY_CONFLICT',
    'RESOURCE_OWNERSHIP_DENIED',
];
/** OPT-08（23 号 §4.3）：个人活动记录视图 */
exports.ACTIVITY_RECORD_VIEWS = ['all', 'tickets', 'checkins', 'participated'];
//# sourceMappingURL=api.js.map